import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Grid, Header, Popup, Icon } from 'semantic-ui-react';

import { Message } from 'components';
import { arrangeSector } from 'utils/helpers';
import { ExposureChart, ExposureTable } from '../components';
import { colors } from '../../../../utils/colors';
import RingChart from '../../../../components/RingChart/RingChart';
import {
  getLabels,
  translateLabels,
  translateText,
} from '../../../../utils/helpers';
import assignColors from '../../../../utils/assignColors';

@connect((state) => ({
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))
export default class MacroFactor extends Component {
  getTableData = (data) => {
    const result = Object.keys(arrangeSector(data)).reduce((total, key) => {
      total.push({
        ticker: key,
        macroRiskExp: data[key],
      });

      return total;
    }, []);
    return result;
  };

  hasNegative = (data) => data.filter((item) => item < 0).length !== 0;

  render() {
    const { data, french, partnerName } = this.props;
    return (
      <Container>
        <Header dividing size="large">
          {french
            ? "Analyse de l'exposition au risque"
            : 'Risk Exposure Analysis'}
          <Header.Subheader>
            <div className="subheader">
              {french ? 'Par ' : 'By '}
              <div className="pill">
                {french ? 'facteur macroéconomique' : 'Macroeconomic Factor'}
              </div>
            </div>
          </Header.Subheader>
        </Header>
        {typeof data.riskExp.F === 'string' ? (
          <Message visible warning>
            {translateText(data.riskExp.F)}
          </Message>
        ) : (
          <div>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <p>
                    {french
                      ? 'Cette section montre la répartition du risque de votre portefeuille à sept facteurs macroéconomiques.'
                      : 'This section shows your portfolio’s risk attribution to seven macroeconomic factors.'}
                  </p>
                  <Header
                    size="medium"
                    content={
                      french
                        ? 'Exposition aux risques macroéconomiques'
                        : 'Macroeconomic Risk Exposure'
                    }
                    style={{ margin: 0 }}
                  />
                  {this.hasNegative(
                    Object.values(arrangeSector(data.riskExp.F))
                  ) ? (
                    <ExposureChart
                      title=""
                      labels={Object.keys(arrangeSector(data.riskExp.F))}
                      data={Object.values(arrangeSector(data.riskExp.F))}
                    />
                  ) : (
                    <div className="chart">
                      <RingChart
                        labels={translateLabels(
                          getLabels(Object.keys(arrangeSector(data.riskExp.F))),
                          french
                        )}
                        values={Object.values(arrangeSector(data.riskExp.F))}
                        maxHeight={350}
                        maxWidth={350}
                        colors={assignColors(
                          getLabels(Object.keys(arrangeSector(data.riskExp.F))),
                          partnerName
                        )}
                      />
                    </div>
                  )}
                </Grid.Column>
                <Grid.Column>
                  <ExposureTable
                    headers={[
                      french ? 'Actif' : 'Asset',
                      <div>
                        {french
                          ? 'Exposition aux risques macroéconomiques'
                          : 'Macroeconomic Risk Exposure'}
                        &nbsp;
                        <Popup
                          trigger={
                            <Icon
                              name="question circle outline"
                              style={{
                                fontSize: '15px',
                                verticalAlign: 'initial',
                                color: 'dimgrey',
                              }}
                            />
                          }
                          position="bottom right"
                          wide
                          style={{ height: 'initial' }}
                          content={
                            french
                              ? 'Un chiffre négatif signifie que votre portefeuille est couvert contre ce facteur. Le risque de votre portefeuille est inversement lié à l’évolution de ce facteur..'
                              : 'A negative number means that your portfolio is hedged against that factor. The risk of your portfolio is negatively related to movements in that factor. Factors with {"-"} risk exposure are statistically insignificant.'
                          }
                        />
                      </div>,
                    ]}
                    totals={['Total', <div>100%</div>]}
                    data={this.getTableData(data.riskExp.F)}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        )}
      </Container>
    );
  }
}

MacroFactor.propTypes = {
  data: PropTypes.object.isRequired,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};

MacroFactor.defaultProps = { french: false, partnerName: '' };

const Container = styled.div`
  padding: 2rem 2rem 1rem 2rem;

  .subheader {
    margin-top: 5px;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    column-gap: 5px;

    .pill {
      background-color: ${colors.lightGrey};
      border-radius: 15px;
      padding: 5px 10px 5px 10px;
      margin: auto;
    }
  }

  .chart {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem 6rem;
  }
`;
